import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CardModule } from "primeng/card";

@Component({
  selector: "jni-download-mobile-app",
  templateUrl: "./download-mobile-app.component.html",
  styleUrls: ["./download-mobile-app.component.scss"],
  imports: [CommonModule, CardModule],
})
export class DownloadMobileAppComponent implements OnInit {
  qrCodeUrl = "";

  constructor(private _router: Router) {}

  ngOnInit() {
    this.generateURL();
  }

  generateURL() {
    if (environment.envName === "Production") {
      this.qrCodeUrl = "../../../assets/images/qr-codes/prod-app-qrcode.png";
    } else if (environment.envName === "Stage1") {
      this.qrCodeUrl = "../../../assets/images/qr-codes/stage1-app-qrcode.png";
    } else if (environment.envName === "Test") {
      this.qrCodeUrl = "../../../assets/images/qr-codes/test-app-qrcode.png";
    } else if (environment.envName === "Dev") {
      this.qrCodeUrl = "../../../assets/images/qr-codes/dev-app-qrcode.png";
    } else {
      this.qrCodeUrl = "../../../assets/images/qr-codes/dev-app-qrcode.png";
    }
  }

  redirectToSalesAppPage() {
    this._router.navigate(["/sales-mobile-app"]);
  }
}
